import 'twin.macro';
import React from 'react';
import {
  AutoSuggest,
  Option,
} from '@teetsh/app/src/components/Form/AutoSuggest';
import Textarea from '@teetsh/app/src/components/Form/Textarea';
import {
  EllipsisVerticalIcon as DotsVertical,
  TrashIcon as Trash,
} from '@heroicons/react/24/outline';
import { DuplicateIcon } from 'components/Icons/icons/Duplicate';
import { LivretEleveCompetence } from '@teetsh/app/src/containers/Livrets/types/livret';
import { useUpdateLivretCompetenceDebounced } from '@teetsh/app/src/containers/Livrets/queries/competences/useUpdateLivretCompetenceDebounced';
import { useDeleteLivretCompetence } from '@teetsh/app/src/containers/Livrets/queries/competences/useDeleteLivretCompetence';
import { Menu } from '@teetsh/app/src/components/Menu';
import { useDuplicateLivretCompetence } from '@teetsh/app/src/containers/Livrets/queries/competences/useDuplicateLivretCompetence';
import _isEmpty from 'lodash-es/isEmpty';
import { useTranslation } from 'react-i18next';

interface Props {
  competence: LivretEleveCompetence;
  options: Option[];
  livretEvalId: string;
  livretEleveId: string;
  matiereId: string;
  domaineId?: string;
}

export function Competence(props: Props) {
  const {
    competence,
    options,
    livretEvalId,
    livretEleveId,
    matiereId,
    domaineId,
  } = props;
  const { t } = useTranslation(['carnet', 'common']);
  const [value, onChange] = useUpdateLivretCompetenceDebounced({
    competence,
    livretEvalId,
    livretEleveId,
    matiereId,
    domaineId,
  });
  const removeCompetence = useDeleteLivretCompetence({
    livretEvalId,
    livretEleveId,
  });

  const duplicateCompetence = useDuplicateLivretCompetence({
    livretEvalId,
    livretEleveId,
  });

  return (
    <div tw="flex items-center">
      <div tw="flex-grow">
        <AutoSuggest
          options={options}
          value={value.name}
          portal
          onBlur={() => {
            if (_isEmpty(value.name)) {
              removeCompetence({ domaineId, matiereId, id: competence.id });
            }
          }}
          onChange={v => {
            onChange({ ...value, name: v });
          }}
          Component={Textarea}
        />
      </div>
      <div>
        <div>
          <Menu>
            <Menu.Button
              minimal
              tw="text-muted font-medium"
              small
              icon={DotsVertical}
            />
            <Menu.Items size="auto">
              <Menu.Item
                tw="whitespace-nowrap"
                onClick={() =>
                  duplicateCompetence({
                    domaineId,
                    matiereId,
                    id: competence.id,
                  })
                }
                icon={DuplicateIcon as any}
                text={t('carnet:livret.copyOnOtherStudents')}
              />
              <Menu.Item
                tw="whitespace-nowrap"
                onClick={() =>
                  removeCompetence({ domaineId, matiereId, id: competence.id })
                }
                icon={Trash}
                intent="danger"
                text={t('carnet:livret.deleteForThisEleveOnly')}
              />

              <Menu.Item
                tw="whitespace-nowrap"
                onClick={() =>
                  removeCompetence({
                    domaineId,
                    matiereId,
                    id: competence.id,
                    all: true,
                  })
                }
                icon={Trash}
                intent="danger"
                text={t('carnet:livret.deleteOnAllEleves')}
              />
            </Menu.Items>
          </Menu>
        </div>
      </div>
    </div>
  );
}
